import { saveIcon } from "assets/images";
import { Box, Button, Card, Grid, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { showLoader } from "utils/helper";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { CONTACT_NOTE_ADD_SUCCESS_MESSAGE } from "utils/constants/Messages";
import {
  CONTACT_NOTE_MAX_LENGTH,
  INPUT_VALIDATION_NO_WHITE_SPACE_WITH_SPECIAL_CHARACTER_REGEX,
} from "utils/constants/constant";
import { IUpdateSLPContactNoteValue } from "utils/interfaces/slp";
import { getSLPContactNoteError } from "utils/helper/validation-message-helper";
import { UpdateSLPContactNotePayload } from "store/slpDashboard/type";
import {
  GetContactNotePayload,
  GetContactNoteSuccessPayload,
} from "store/studentProfileDetails/types";

interface IContactNoteProps {
  getContactNoteRequest: (payload: GetContactNotePayload) => {};
  editcontactNoteRequest: (payload: UpdateSLPContactNotePayload) => {};
}

const ContactNote: React.FC<IContactNoteProps> = ({
  getContactNoteRequest,
  editcontactNoteRequest,
}) => {
  const [contactNote, setContactNote] = useState<string | null>(null);
  const history = useHistory();
  const location = useLocation<{
    slpId: number;
  }>();

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm<IUpdateSLPContactNoteValue>({
    defaultValues: {
      id: location.state.slpId,
      note: contactNote,
    },
  });

  const onEditContactNoteSuccess = (data: IUpdateSLPContactNoteValue) => {
    setContactNote(data.note ?? null);
    toast.success(CONTACT_NOTE_ADD_SUCCESS_MESSAGE);
  };
  const handleCancelClick = () => {
    reset({ id: location.state.slpId, note: contactNote });
  };

  const handleSaveClick = (data: IUpdateSLPContactNoteValue) => {
    if (location.state.slpId) {
      if (editcontactNoteRequest) {
        showLoader();
        const payload: UpdateSLPContactNotePayload = {
          value: {
            id: data.id,
            note: data.note?.trim() ?? null,
          },
          callback: onEditContactNoteSuccess,
        };
        editcontactNoteRequest(payload);
      }
    }
  };

  const onGetContactNoteSuccess = (response: GetContactNoteSuccessPayload) => {
    setContactNote(response?.item);
  };

  const getContactNote = () => {
    if (getContactNoteRequest) {
      showLoader();
      const { slpId } = location.state;

      const payload: GetContactNotePayload = {
        values: { sLPId: slpId },
        callback: onGetContactNoteSuccess,
      };

      getContactNoteRequest(payload);
    }
  };

  useEffect(() => {
    if (location?.state?.slpId) {
      getContactNote();
    } else {
      history.goBack();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue("note", contactNote);
  }, [setValue, contactNote]);

  return (
    <>
      <Card>
        <Box className="card-inner-head mb-24">
          <Typography variant="h3" sx={{ fontWeight: 500 }}>
            Contact Note
          </Typography>
        </Box>
        <form onSubmit={handleSubmit(handleSaveClick)}>
          <Grid container spacing={{ xs: "16px", lg: "20px", xl: "24px" }}>
            <Grid item xs={12}>
              <TextField
                label="Contact Note"
                multiline
                fullWidth
                className="std-notes-textarea"
                rows={3}
                variant="outlined"
                InputLabelProps={{
                  shrink: Boolean(watch("note")),
                }}
                sx={{ mb: 0 }}
                {...register("note", {
                  maxLength: CONTACT_NOTE_MAX_LENGTH,
                  pattern:
                    INPUT_VALIDATION_NO_WHITE_SPACE_WITH_SPECIAL_CHARACTER_REGEX,
                })}
                error={!!errors.note}
                helperText={getSLPContactNoteError(errors.note)}
              />
            </Grid>
            <Grid item xs={12}>
              <Box className="btn-group">
                <Button variant="contained" type="submit" className="btn-save">
                  <img src={saveIcon} alt="save" />
                  Save
                </Button>
                <Button
                  onClick={handleCancelClick}
                  variant="outlined"
                  className="btn-cancel"
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Card>
    </>
  );
};
export default ContactNote;
